import { MissingArgumentsError } from 'src/app/models/errors/general.errors';
import { getDetailsEditUrl } from './edit.urls';

export const SUBTITLES_URL = '/subtitles';

export function geteEditSpecificStyleUrl(projectId: string, editId: string, settingId: string) {
    if (!projectId || !editId || !settingId) {
        throw new MissingArgumentsError(
            `Could not get specific style url because one of the arguments is null is null`
        );
    }

    const generalStyleUrl = getStylesDetailsUrl(projectId, editId, settingId);
    return `${generalStyleUrl}`;
}

export function getStylesDetailsUrl(projectId: string, editId: string, settingId: string): string {
    if (!editId) {
        throw new Error(`Could not get style url because edit id is null`);
    }

    const baseStyleGeneralUrl = getStylesGeneralUrl(projectId, editId);
    return `${baseStyleGeneralUrl}/${settingId}`;
}
export function getAlignmentUrl(projectId: string, editId: string): string {
    if (!editId) {
        throw new Error(`Could not get style url because edit id is null`);
    }

    const baseStyleGeneralUrl = getStylesGeneralUrl(projectId, editId);
    return `${baseStyleGeneralUrl}/alignment`;
}
export function getChangeLanguagePUTUrl(projectId: string, editId: string): string {
    if (!editId) {
        throw new Error(`Could not get style url because edit id is null`);
    }
    const baseStyleUrl = getStylesGeneralUrl(projectId, editId);
    return `${baseStyleUrl}/language`;
}

export function getStylesGeneralUrl(projectId: string, editId: string): string {
    if (!editId) {
        throw new Error(`Could not get style url because edit id is null`);
    }

    const baseEditUrl = getDetailsEditUrl(projectId, editId);
    return `${baseEditUrl}${SUBTITLES_URL}`;
}
